// Importación de Axios
import axios from "axios";

// Store de Vuex
import store from "../store";

// Importación de constantes .env
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

export const login = async (data) => {
  let dataUsuario;

  let ip = "";

  try {
    const { data } = await axios.get('https://api.ipify.org?format=json');
    ip = data.ip
  } catch (error) {
    ip = "";
  }

  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/login`, {
      username: data.userModel,
      password: data.passwordModel,
      ip
    },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then(function ({ data }) {
      dataUsuario = data;
    })
    .catch(({ response }) => {
      console.log(response);
    });

  return dataUsuario;
};

export const validateToken = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/validateToken`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then(({ data }) => data);

export const uploadFile = async (file, id, nameFolder) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Variable para mostrar loading
  store.state.uploadFileLoading = true;
  store.state.uploadFileLoadingError = false;

  // Creación de un nuevo objeto formulario
  var dataForm = new FormData();

  // Se agrega el archivo file al formulario con el mismo nombre
  dataForm.append("file", file);
  dataForm.append("id", id);
  dataForm.append("nameFolder", nameFolder);

  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/fileUpload`, dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;

      // Variable para mostrar loading
      store.state.uploadFileLoading = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;

      // Variable para mostrar loading
      store.state.uploadFileLoading = false;
      store.state.uploadFileLoadingError = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const getFile = async (id, url) => {
  let dataResponse;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/getFile`,
      {
        id,
        url,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  return dataResponse;
};

export const getFileUrl = async (path, id, name) => {

  let dataResponse;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/getFileUrl`, {
      path,
      id,
      name
    },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "arraybuffer"
      }
    )
    .then(function ({ data, status }) {
      dataResponse = { data, status };
    })

    .catch(({ response }) => {
      dataResponse = { 'data': response.data, 'status': response.data };
    });

  return dataResponse;
};

export const deleteFile = async (id_file, url, id) => {
  let dataResponse;

  // Variable para mostrar loading
  store.state.uploadFileLoading = true;
  store.state.uploadFileLoadingError = false;

  await axios
    .delete(
      `${RUTA_SERVIDOR_BACKEND}/deleteFile/${id_file}/${url}/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;

      // Variable para mostrar loading
      store.state.uploadFileLoading = false;
    })

    .catch(({ response }) => {
      // Variable para mostrar loading
      store.state.uploadFileLoading = false;
      store.state.uploadFileLoadingError = true;

      dataResponse = response.data;
    });

  return dataResponse;
};


export const cerrarSesionUsuario = async (id_user) => {
  let dataResponse;

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/cerrarSesionUsuario`,
      {
        id_user
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
    });

  return dataResponse;
};

export const descargarBookingPDF = async ({ id_booking, name }) => {

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getBookingPDF/${id_booking}/${name}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      responseType: 'arraybuffer',
    })
    .then((response) => {


      console.log(response);

      let blob = new Blob([response.data], {
        type: 'application/pdf'
      })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${name}.pdf`
      link.click()

    });
};

//descargar BL PDF
export const downloadBillLadingPDF = async (data, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/getBillLadingPDF`,
    data,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/pdf"
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.pdf`;
      link.click();
    });
};


export const buscarReserva = async form => {

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/searchBooking`, {
    tipo: form.tipo.toLowerCase(),
    identificador: form.identificador,
  },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
  );
  return data;
};

export const searchSI = async form => {

  const { data } = await axios.post(`${RUTA_SERVIDOR_BACKEND}/searchSI`, form,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
  );

  return data;
};

